import * as React from "react";
import ErrorText from "../../../../components/atoms/ErrorText/index";
import { ApiErrorInterface } from "../../../../interfaces/ApiErrorResponseInterface";

interface Props {
  errors: ApiErrorInterface[];
}

const ApiErrors: React.FC<Props> = ({ errors }) => {
  if (errors.length === 0) {
    return null;
  }

  return (
    <>
      {errors.map((err: ApiErrorInterface, idx: number) => (
        <ErrorText key={`inviteError-${idx}`}>{err.message}</ErrorText>
      ))}
    </>
  );
};

export default ApiErrors;
